var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['panel']},[_c('SearchForm',{class:_vm.$style['form'],attrs:{"is-mock":!!_vm.$store.state.admin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }